import { useMediaQuery } from '../react/core/useMediaQuery';
export const hiddenAtXlDown = { display: { xs: 'none', xl: 'block' } };
export const hiddenAtLgDown = { display: { xs: 'none', lg: 'block' } };
export const hiddenAtMdDown = { display: { xs: 'none', md: 'block' } };
export const hiddenAtSmDown = { display: { xs: 'none', sm: 'block' } };
export const hiddenAtXlOnly = { display: { lg: 'block', xl: 'none' } };
export const hiddenAtLgOnly = { display: { md: 'block', lg: 'none', xl: 'block' } };
export const hiddenAtMdOnly = { display: { sm: 'block', md: 'none', lg: 'block' } };
export const hiddenAtSmOnly = { display: { xs: 'block', sm: 'none', md: 'block' } };
export const hiddenAtXsOnly = { display: { xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' } };
export const hiddenAtXlUp = { display: { xs: 'block', xl: 'none' } };
export const hiddenAtLgUp = { display: { xs: 'block', lg: 'none' } };
export const hiddenAtMdUp = { display: { xs: 'block', md: 'none' } };
export const hiddenAtSmUp = { display: { xs: 'block', sm: 'none' } };
export const useMediaQueryHiddenDown = (size) => (useMediaQuery((theme) => theme.breakpoints.down(size)));
export const useMediaQueryHiddenOnly = (size) => (useMediaQuery((theme) => theme.breakpoints.only(size)));
export const useMediaQueryHiddenUp = (size) => (useMediaQuery((theme) => theme.breakpoints.up(size)));
